import { FC } from 'react';
import { DefaultChip } from 'shared/DefaultChip';

export const PublicBetaTag: FC = () => {
  return <DefaultChip color="info" label="Public Beta" variant="outlined" />;
};
